export default __webpack_public_path__ + "static/media/boosty_249.7829b4bf.png";